import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import CommManager from "../../../vendor_core/core/src/controllers/CommManager";
import requestRegister from "../../../vendor_core/core/src/server/requests/RequestRegister"
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import ErrorModel from "../../../vendor_core/core/src/model/ErrorModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import BBModel from "../model/BBModel";
import VendorModel from '../../../vendor_core/server/model/VendorModel';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import RealityCheckModel from '../../../vendor_core/core/src/model/RealityCheckModel';

export default class BBSpinRequestState extends State {
    public enter(): void {
        super.enter();

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.hideLinesAndInfo(true);
        if (AutoplayModel.isAutoSpinActive()) {
            UIController.setState(UIStates.AUTO);
        } else {
            UIController.setState(UIStates.SPIN);
        }
        this.startSpin();
        // if (!SpinModel.isInFreespins()) {
        //     reelGroup.winSymbolsView.unlockAll();
        // }
        if (!SpinModel.isInFreespins() && !AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.CLEAR_WIN);
        }
        if (SpinModel.isInFreespins && SpinModel.freespinsNum == 1) {
            // this.addFreespinBanner(reelGroup)
        }

        // this.exit();
    }

    protected startSpin() {
        if (AutoplayModel.isAutoSpinActive()) {
            if (!SpinModel.isInFreespins()) {
                CommandManager.execute(Commands.CLEAR_WIN);
            }
            this.sendRequest();
        } else {
            this.sendRequest();
        }
        // SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, true, 1);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);
    }

    sendRequest() {
        BetModel.betTime = Date.now();
        if (!SpinModel.isInFreespins()) {
            UIController.updateFields(UIUpdateEvent.Balance);
            SpinModel.spinFinished = false;
            CommManager.send(
                requestRegister.get("playRequest"),
                this.onResponse,
                this,
                (data) => {
                    ConsoleUtil.red("ERROR-REQ", data)
                    // console.log("-----------------------------------------------------------------------");
                    // console.log("Error:", data);
                    if (data.type && data.type == "error") {
                        console.log("[RelaxComm] Error model:", data);
                        ErrorModel.update({
                            errorCode: 404,
                            errorMessage: "Connection error!",
                            critical: true,
                        });
                    } else {
                        ErrorModel.update(data);
                    }
                    this.exit()
                }
            );
        } else {
            // TweenMax.delayedCall(0.2, () => {
            //     this.onResponse();
            // });
            this.onResponse();
        }
    }

    protected onResponse(data?: any) {

        // console.log('spins data----------------------------------------------');
        // console.log('spins data:', data);
        SpinModel.update(data);
        BBModel.update(data);
        ErrorModel.update(data);
        VendorModel.update(data);
        !!data && RealityCheckModel.update(data.stats.realityCheck);
        
        if (!SpinModel.isInFreespins()) {
            BetModel.update(data);
        } else {
            this.anounce();
        }

        this.updateFields();
            this.exit();
        }

    protected updateFields() {
        if (SpinModel.isInFreespins()) {

            if ((SpinModel.freespinsWon - SpinModel.freespinsNum) == SpinModel.freespinsWon ) {
                CommandManager.execute(
                    Commands.UPDATE_FREE_SPINS,
                    (SpinModel.freespinsWon - SpinModel.freespinsNum).toString() + "/" + (SpinModel.freespinsWon).toString())

                // BBAnimationsHelper.playTextPopupBanner(Locale.getString("last_freespin"), 2, 1);
            } else {
                CommandManager.execute(
                    Commands.UPDATE_FREE_SPINS,
                    (SpinModel.freespinsWon - SpinModel.freespinsNum).toString() + "/" + (SpinModel.freespinsWon).toString()
                )
            }
        } else {
            // CommandManager.execute(Commands.CLEAR_WIN);
        }
    }

    protected anounce() {
        SpinModel.freespinsToShow -= 1;
    }
}
